import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarServicePages } from "@/data/solarServiceContent";

export const Route = createFileRoute("/services/solar-installation")({
  head: () => ({
    meta: [
      { title: "Solar Installation in Southern California – McKay Roofing & Solar" },
      { name: "description", content: "Custom solar installations across Southern California. Full design, permits and utility interconnection by a team that handles the roof first." },
      { property: "og:title", content: "Solar Installation in Southern California – McKay Roofing & Solar" },
      { property: "og:description", content: "Custom solar installations sized for your home and roof in Southern California." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-installation" }],
  }),
  component: () => <RoofingServicePage {...solarServicePages["solar-installation"]} />,
});